import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@ddt-web/common';

import { StepNavigationService } from './service/step-navigation.service';
import { StepNavigationComponent } from './step-navigation.component';

@NgModule({
	declarations: [StepNavigationComponent],
	imports: [CommonModule, RouterModule, SharedModule],
	exports: [StepNavigationComponent],
	providers: [StepNavigationService]
})
export class StepNavigationModule { }
